import { useTranslation } from 'react-i18next';

import { TrendingValue } from '@/components/TrendingValue/TrendingValue';
import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';
import { Support } from '@/services/types/commonResponse';

import styles from './styles.module.css';

interface CardSupportMobileProps {
  readonly index: number;
  readonly openModal: (index: number) => void;
  readonly showFilter: boolean;
  readonly support: Support;
}

export default function CardSupportMobile({ index, openModal, showFilter, support }: CardSupportMobileProps) {
  const { t } = useTranslation();

  const getModeGestionText = () => {
    if (support?.modeGestionLibelle === 'Pilotée A Horizon') {
      return 'Gestion Pilotée à Horizon Retraite';
    } else {
      return `Gestion ${support?.modeGestionLibelle}`;
    }
  };

  return (
    <div className={styles.cardSupportMobile} key={index}>
      <div className={styles.supportNameMobile}>
        {support?.nomSupport}
        {showFilter && <span>{getModeGestionText()}</span>}
      </div>

      <div>
        {' '}
        <div className={styles.amountPercentageMobile}>
          <span className={styles.amountMobile}>
            {typeof support?.allocation === 'number'
              ? t('format.currencyFlexible', { value: support.allocation })
              : t('common.infoUnavailable')}{' '}
          </span>
          <span>
            {typeof support?.poids === 'number'
              ? `(${t('format.percentFlexible', { value: support.poids })})`
              : `(${t('common.infoUnavailable')})`}
          </span>{' '}
        </div>
        {support.pmvEuro == null && (
          <button
            onClick={() => {
              openModal(index);
              void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
                event_id: 'clic',
                event_categorie: 'clic',
                event_metier: 'espace client placement',
                event_nom: 'voir plus support',
                event_detail_1: 'picto',
              });
            }}
          >
            <i className="totem-icon totem-icon-dots" />
          </button>
        )}
      </div>
      {support.pmvEuro !== null && (
        <div className={styles.performanceSupportMobile}>
          <TrendingValue
            value={support?.pmvEuro || 0}
            secondaryValue={support?.pmvPct || 0}
            secondaryValueParentheses={false}
          />
          <button
            onClick={() => {
              openModal(index);
              void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
                event_id: 'clic',
                event_categorie: 'clic',
                event_metier: 'espace client placement',
                event_nom: 'voir plus support',
                event_detail_1: 'picto',
              });
            }}
          >
            <i className="totem-icon totem-icon-dots" />
          </button>
        </div>
      )}
    </div>
  );
}
